//  ./fileSlice.ts
//  This is for the sending files to the backend

import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface File {
  name: string;
  // Add other file properties if needed
}

interface FilesState {
  files: File[];
}

const initialState: FilesState = {
  files: [],
};

const filesSlice = createSlice({
  name: 'files',
  initialState,
  reducers: {
    addFile: (state, action: PayloadAction<string>) => {
      const newFile: File = { name: action.payload };
      state.files.push(newFile);
    },
    setFiles: (state, action: PayloadAction<File[]>) => {
      state.files = action.payload;
    },
  },
});

export const { addFile, setFiles } = filesSlice.actions;

export default filesSlice.reducer;
